import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index/index'
import product from '../pages/product/product'
import recommend from '../pages/recommend/recommend'
import plan from '../pages/plan/plan'
import login from '../pages/login/login'
import planDetail from '../pages/planDetail/planDetail'
import my from '../pages/my/index/index'
import direction from '../pages/my/direction/direction'
import extract from '@/pages/my/extract/extract'
import extractRecord from '@/pages/my/extractRecord/extractRecord'
import jifen from '@/pages/my/jifen/jifen'
import personalInfo from '@/pages/my/personalInfo/personalInfo'
import proposal from '@/pages/my/proposal/proposal'
import poster from '@/pages/poster/poster'
import fenxiang from '@/pages/fenxiang/fenxiang'
import productDetail from '@/pages/productDetail/productDetail'
import search from '@/pages/search/search'
import newDetail from '@/pages/newDetail/newDetail'
import orderCar from '@/pages/orderCar/orderCar'
import regProtocol from '@/pages/regProtocol/regProtocol'
import taskDetail from '@/pages/taskDetail/taskDetail'
import loading from '@/pages/loading/loading'

Vue.use(Router)

Router.prototype.go = function () {
 this.isBack = true
 window.history.go(-1)
}

export default new Router({
  mode:'history',
  base: "/tgds/",
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: { keepAlive: true }         
    },   
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/product',
      name: 'product',
      component: product,
       meta: { keepAlive: true }     
    },
    {
      path: '/recommend',
      name: 'recommend',
      component: recommend
    },
    {
      path: '/my',
      name: 'my',
      component: my
    },
    {
      path: '/plan',
      name: 'plan',
      component: plan
    },
    {
      path: '/planDetail',
      name: 'planDetail',
      component: planDetail
    },
    {
      path: '/direction',
      name: 'direction',
      component: direction
    },
    {
      path: '/extract',
      name: 'extract',
      component: extract
    },
    {
      path: '/extractRecord',
      name: 'extractRecord',
      component: extractRecord
    },
    {
      path: '/jifen',
      name: 'jifen',
      component: jifen
    },
    {
      path: '/personalInfo',
      name: 'personalInfo',
      component: personalInfo
    },
    {
      path: '/proposal',
      name: 'proposal',
      component: proposal
    },
    {
      path: '/fenxiang',
      name: 'fenxiang',
      component: fenxiang,
       meta: { keepAlive: true }      
    }, 
    {
      path: '/productDetail',
      name: 'productDetail',
      component: productDetail
    },
    {
      path: '/search',
      name: 'search',
      component: search
    }, 
    {
      path: '/newDetail',
      name: 'newDetail',
      component: newDetail
    },
    {
      path: '/poster',
      name: 'poster',
      component: poster
    }, 
    {
      path: '/orderCar',
      name: 'orderCar',
      component: orderCar
    },
    {
      path: '/regProtocol',
      name: 'regProtocol',
      component: regProtocol
    },
    {
      path: '/taskDetail',
      name: 'taskDetail',
      component: taskDetail
    }, 
    {
      path: '/loading',
      name: 'loading',
      component: loading
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js